export const PADDING = 24;

export const DRAWER_WIDTH = 270;
export const TOC_WIDTH = 200;

export const PAGE_WIDTH = {
    WIDE: 1280, // medias, components
    REGULAR: 766 + PADDING * 2, // text
};

export const CTA_BUTTON = {
    WIDTH: 320 - PADDING * 2,
    HEIGHT: 154,
};

export const REGULAR_WIDTH_STYLE = {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: PAGE_WIDTH.REGULAR,
};
